import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Phone, Mail, MapPin, MessageCircle, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!email) { toast.error("Enter your email."); return; }
    setLoading(true);
    try {
      const res = await api.post("/subscribe", { email });
      if (res.data.status === "exists") toast.info("You're already on our list.");
      else toast.success("Subscribed! We'll send you our latest offers.");
      setEmail("");
    } catch { toast.error("Subscription failed. Try again."); }
    finally { setLoading(false); }
  };
  return (
    <form onSubmit={submit} className="mt-8 flex max-w-sm" data-testid="newsletter-form">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email for offers"
        data-testid="newsletter-email"
        className="flex-1 bg-white/5 border border-white/20 px-4 py-3 text-white placeholder:text-white/40 focus:outline-none focus:border-emerald text-sm"
      />
      <button type="submit" disabled={loading} data-testid="newsletter-submit"
        className="bg-emerald text-navy px-4 flex items-center justify-center hover:bg-white transition-colors disabled:opacity-50">
        <ArrowRight size={18} />
      </button>
    </form>
  );
};

export const Footer = () => (
  <footer data-testid="main-footer" className="bg-navy text-white relative grain overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 relative z-10">
      <div className="grid md:grid-cols-12 gap-12 border-b border-white/15 pb-16">
        <div className="md:col-span-5">
          <div className="font-display font-black text-3xl tracking-tight">SAYE IMPEX</div>
          <div className="font-mono text-xs tracking-[0.25em] text-emerald mt-1">RECYCLING INC</div>
          <p className="mt-6 text-white/60 max-w-sm text-sm leading-relaxed">
            A Canadian plastic recycling and export company specializing in the direct purchase,
            recovery and global placement of stock lots and post-industrial recyclable plastic.
          </p>
          <div className="font-mono text-xs uppercase tracking-widest text-white/40 mt-8">Get our latest offers</div>
          <NewsletterForm />
        </div>

        <div className="md:col-span-3">
          <div className="font-mono text-xs uppercase tracking-widest text-white/40 mb-5">Navigate</div>
          <ul className="space-y-3 text-sm">
            {["Home", "Services", "Products", "Offers", "About", "Contact"].map((l) => (
              <li key={l}>
                <Link to={l === "Home" ? "/" : `/${l.toLowerCase()}`}
                  className="text-white/80 hover:text-emerald transition-colors">{l}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="font-mono text-xs uppercase tracking-widest text-white/40 mb-5">Get in touch</div>
          <ul className="space-y-4 text-sm">
            <li className="flex items-center gap-3"><Phone size={16} className="text-emerald" /><a href="tel:+17789877884" className="hover:text-emerald">+1-778-987-7884</a></li>
            <li className="flex items-center gap-3"><MessageCircle size={16} className="text-emerald" /><span>WhatsApp: 778-987-7884 / 647-685-2707</span></li>
            <li className="flex items-center gap-3"><Mail size={16} className="text-emerald" /><a href="mailto:pmpsar@gmail.com" className="hover:text-emerald">pmpsar@gmail.com</a></li>
            <li className="flex items-center gap-3"><MapPin size={16} className="text-emerald" /><span>British Columbia, Canada</span></li>
          </ul>
        </div>
      </div>

      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 pt-8">
        <span className="font-mono text-xs text-white/40">© {new Date().getFullYear()} SAYE IMPEX RECYCLING INC. All rights reserved.</span>
        <Link to="/admin" data-testid="footer-admin-link" className="font-mono text-xs text-white/30 hover:text-emerald transition-colors">Admin Portal</Link>
      </div>
    </div>
  </footer>
);
